import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Helper to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('agentiq_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Auth APIs
export const authAPI = {
  signup: async (data) => {
    const response = await axios.post(`${API}/auth/signup`, data);
    return response.data;
  },
  
  login: async (data) => {
    const response = await axios.post(`${API}/auth/login`, data);
    return response.data;
  },
  
  getMe: async () => {
    const response = await axios.get(`${API}/auth/me`, { headers: getAuthHeaders() });
    return response.data;
  }
};

// Agent APIs
export const agentAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/agents`, { headers: getAuthHeaders() });
    return response.data;
  },
  
  create: async (data) => {
    const response = await axios.post(`${API}/agents`, data, { headers: getAuthHeaders() });
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/agents/${id}`, { headers: getAuthHeaders() });
    return response.data;
  }
};

// SOP APIs
export const sopAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/sops`, { headers: getAuthHeaders() });
    return response.data;
  },
  
  create: async (data) => {
    const response = await axios.post(`${API}/sops`, data, { headers: getAuthHeaders() });
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await axios.put(`${API}/sops/${id}`, data, { headers: getAuthHeaders() });
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/sops/${id}`, { headers: getAuthHeaders() });
    return response.data;
  }
};

// Scorecard APIs
export const scorecardAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/scorecards`, { headers: getAuthHeaders() });
    return response.data;
  },
  
  create: async (data) => {
    const response = await axios.post(`${API}/scorecards`, data, { headers: getAuthHeaders() });
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/scorecards/${id}`, { headers: getAuthHeaders() });
    return response.data;
  }
};

// QA Session APIs
export const qaAPI = {
  getAll: async (agentId = null, limit = 50) => {
    const params = { limit };
    if (agentId) params.agent_id = agentId;
    const response = await axios.get(`${API}/qa-sessions`, {
      headers: getAuthHeaders(),
      params
    });
    return response.data;
  },
  
  create: async (data) => {
    const response = await axios.post(`${API}/qa-sessions`, data, { headers: getAuthHeaders() });
    return response.data;
  }
};

// Training Session APIs
export const trainingAPI = {
  getAll: async (agentId = null, limit = 50) => {
    const params = { limit };
    if (agentId) params.agent_id = agentId;
    const response = await axios.get(`${API}/training-sessions`, {
      headers: getAuthHeaders(),
      params
    });
    return response.data;
  },
  
  create: async (data) => {
    const response = await axios.post(`${API}/training-sessions`, data, { headers: getAuthHeaders() });
    return response.data;
  }
};

// AI APIs
export const aiAPI = {
  chatTraining: async (data) => {
    const response = await axios.post(`${API}/ai/chat-training`, data);
    return response.data;
  },
  
  scoreTraining: async (data) => {
    const response = await axios.post(`${API}/ai/score-training`, data);
    return response.data;
  },
  
  generateScenarios: async (sopText) => {
    const response = await axios.post(`${API}/ai/generate-scenarios`, { sop_text: sopText });
    return response.data;
  }
};

// Dashboard Stats API
export const statsAPI = {
  getStats: async () => {
    const response = await axios.get(`${API}/stats`, { headers: getAuthHeaders() });
    return response.data;
  }
};

export default {
  auth: authAPI,
  agents: agentAPI,
  sops: sopAPI,
  scorecards: scorecardAPI,
  qa: qaAPI,
  training: trainingAPI,
  ai: aiAPI,
  stats: statsAPI
};
